import { z } from 'my-zod'
import { enumOptionsToObject } from './enum-helpers'

export const ibmiProductLineEnum = z.enum([
  'ATV',
  'BEN',
  'BRU',
  'COM',
  'GDY',
  'GEN',
  'HUR',
  'IND',
  'LEV',
  'MIL',
  'OSP',
  'PWC',
  'RGR',
  'RZR',
  'SLG',
  'SNO',
  'TLD',
  'TSL',
  'VIC',
  'XVR',
  'YTH'
])
export type ibmiProductLine = z.infer<typeof ibmiProductLineEnum>

export const ibmiProductLineOptions = Object.values(ibmiProductLineEnum.Values)
export const ibmiProductLines = enumOptionsToObject(ibmiProductLineOptions)
